import React, { useState } from "react";
import { Card, Button, Alert, Spinner } from "react-bootstrap";
import EventCompleteRoundTd from "./EventCompleteRoundTd";
import EventCompleteRoundFalseTd from "./EventCompleteRoundFalseTd";
import DivisionPayoutPools from "./DivisionPayoutPools";
import { useEventDivisions, saveEventPayouts } from "../util/db";
import { calculateDivisionPayouts } from "../util/payoutCalculations";
// import EventCalculatePayoutsTd from './EventCalculatePayoutsTd'
import { useGroupScorecardsNotComplete } from "./../util/db";
// import { updateEventCompleteTrue } from "./../util/db";

function EventManageComplete(props) {
  const [isCalculatingPayouts, setIsCalculatingPayouts] = useState(false);
  const [payoutStatus, setPayoutStatus] = useState(null); // null, 'success', 'error'
  const [payoutMessage, setPayoutMessage] = useState("");
  const [divisionSettings, setDivisionSettings] = useState({});

  const {
    data: items,
    // status: itemsStatus,
    // error: itemsError,
  } = useGroupScorecardsNotComplete(props.eventId);

  // Get divisions data for payout calculations
  const {
    data: divisions,
    // status: divisionsStatus
  } = useEventDivisions(props.eventId);

  let isLiveScorecards = 0;

  //if there are items (hook is complete, no errors)loop through items
  if (items !== null && items !== undefined) {
    items.forEach((item, index) => {
      //if group_scorecard_players is not empty, set isLiveScorecards to 1
      if (item.group_scorecard_players.length > 0) {
        isLiveScorecards = 1;
      }
    });
  }

  // Handle Award Payouts button click
  const handleAwardPayouts = async () => {
    if (!props.isEventComplete) {
      setPayoutStatus("error");
      setPayoutMessage("Event must be completed before awarding payouts.");
      return;
    }

    if (!divisions) {
      setPayoutStatus("error");
      setPayoutMessage("Division data not loaded. Please try again.");
      return;
    }

    setIsCalculatingPayouts(true);
    setPayoutStatus(null);
    setPayoutMessage("");

    try {
      // Collect all payout data for database insertion
      const allPayoutData = [];

      // Process each division
      for (const division of divisions) {
        // Get the actual division settings that the user has selected in the UI
        const currentDivisionSettings = divisionSettings[
          division.event_divisions_id
        ] || {
          payoutPercentage: 40,
          selectedPaytableId: null, // Will fall back to equal distribution
        };

        try {
          // Use the shared payout calculation utility
          const payoutResult = await calculateDivisionPayouts({
            eventId: props.eventId,
            division,
            divisionSettings: currentDivisionSettings,
            scoringOrderGolf: props.scoringOrderGolf,
          });

          // Add this division's payout data to the collection
          allPayoutData.push(...payoutResult.payoutData);
        } catch (error) {
          console.error(
            `Error calculating payouts for division ${division.divisions.name}:`,
            error
          );
          // Continue with other divisions even if one fails
          continue;
        }
      }

      // Log the calculated payouts for debugging
      console.log("=== AWARD PAYOUTS DEBUG ===");
      console.log("Total payouts calculated:", allPayoutData.length);
      console.log("Payout data:", allPayoutData);
      console.log("Payouts by division:");

      // Group payouts by division for clearer logging
      const payoutsByDivision = allPayoutData.reduce((acc, payout) => {
        if (!acc[payout.division_name]) {
          acc[payout.division_name] = [];
        }
        acc[payout.division_name].push(payout);
        return acc;
      }, {});

      Object.entries(payoutsByDivision).forEach(([divisionName, payouts]) => {
        console.log(`\n${divisionName}:`);
        payouts.forEach((payout) => {
          const roundedPayout = Math.round(payout.payout * 100) / 100;
          console.log(
            `  Rank ${payout.rank}: ${
              payout.player_name
            } - $${roundedPayout.toFixed(2)} (${(
              payout.percentage * 100
            ).toFixed(1)}%)`
          );
        });
        const divisionTotal = payouts.reduce(
          (sum, p) => sum + Math.round(p.payout * 100) / 100,
          0
        );
        console.log(`  Division Total: $${divisionTotal.toFixed(2)}`);
      });

      const grandTotal = allPayoutData.reduce(
        (sum, payout) => sum + Math.round(payout.payout * 100) / 100,
        0
      );
      console.log(`\nGrand Total: $${grandTotal.toFixed(2)}`);
      console.log("========================");

      // Save payouts to database
      console.log("Saving payouts to database...");
      const result = await saveEventPayouts(props.eventId, allPayoutData);
      console.log("Payouts saved successfully:", result);

      if (result.deletedPayoutsCount > 0) {
        console.log(
          `⚠️  Removed ${result.deletedPayoutsCount} existing payouts before saving new ones`
        );
      }

      // Prepare success message based on whether existing payouts were removed
      let successMessage = `Payouts have been awarded successfully! ${allPayoutData.length} payouts processed and saved to database.`;

      if (result.deletedPayoutsCount > 0) {
        successMessage = `Payouts have been re-awarded successfully! Removed ${result.deletedPayoutsCount} existing payouts and saved ${result.insertedPayoutsCount} new payouts to database.`;
      }

      setPayoutStatus("success");
      setPayoutMessage(successMessage);
    } catch (error) {
      console.error("Error awarding payouts:", error);
      setPayoutStatus("error");
      setPayoutMessage("Failed to award payouts. Please try again.");
    } finally {
      setIsCalculatingPayouts(false);
    }
  };

  return (
    <>
      {/* Division Payout Pools with Tabs */}
      <DivisionPayoutPools
        eventId={props.eventId}
        scoringOrderGolf={props.scoringOrderGolf}
        throwScoringModeId={props.throwScoringModeId}
        onSettingsReady={setDivisionSettings}
      />

      <Card
        style={{ borderRadius: "12px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}
        className="mb-3"
      >
        <Card.Header
          style={{
            background: "#2D083F",
            color: "white",
            borderRadius: "12px 12px 0 0",
          }}
        >
          <Card.Title className="mb-0" style={{ color: "white" }}>
            Complete Event
          </Card.Title>
        </Card.Header>
        <Card.Body
          style={{
            background: "#FFFFFF",
            borderRadius: "0 0 12px 12px",
            padding: "1.5rem",
          }}
        >
          <div className="text-center">
            {/* Payout Status Alert */}
            {payoutStatus && (
              <Alert
                variant={payoutStatus === "success" ? "success" : "danger"}
                className="mb-3"
              >
                {payoutMessage}
              </Alert>
            )}

            {props.isEventComplete ? (
              <>
                <EventCompleteRoundFalseTd
                  eventId={props.eventId}
                  isEventComplete={props.isEventComplete}
                />

                {/* Award Payouts Section */}
                <div className="mt-4 pt-3 border-top">
                  <h6 className="mb-3" style={{ color: "#2D083F" }}>
                    Award Payouts
                  </h6>
                  <Button
                    variant="success"
                    size="lg"
                    onClick={handleAwardPayouts}
                    disabled={isCalculatingPayouts}
                    style={{
                      minWidth: "200px",
                      fontWeight: "600",
                    }}
                  >
                    {isCalculatingPayouts ? (
                      <>
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                        Awarding...
                      </>
                    ) : (
                      "💰 Award Payouts"
                    )}
                  </Button>
                  <div className="mt-2">
                    <small className="text-muted">
                      This will save calculated payouts to the database
                    </small>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* Event Not Complete Section */}
                <div className="mb-3">
                  <h6 style={{ color: "#2D083F" }}>Complete Event First</h6>
                  <p className="text-muted">
                    You must complete the event before calculating payouts.
                  </p>
                </div>

                {/* Original Complete Event Logic */}
                {isLiveScorecards > 0 ? (
                  <EventCompleteRoundTd
                    eventId={props.eventId}
                    isEventComplete={props.isEventComplete}
                    disabled={true}
                  />
                ) : (
                  <EventCompleteRoundTd
                    eventId={props.eventId}
                    isEventComplete={props.isEventComplete}
                    disabled={false}
                  />
                )}
              </>
            )}
          </div>
        </Card.Body>
      </Card>
    </>
  );
}

export default EventManageComplete;
